module.exports = __webpack_public_path__ + "static/media/betano.5378aff2.webp";